import { useState } from "react";
import Select from "./components/Select";
import MultiSelect from "./components/MultiSelect";

const options = [
  { label: "First", value: 1 },
  { label: "Second", value: 2 },
  { label: "Third", value: 3 },
  { label: "Fourth", value: 4 },
  { label: "Fifth", value: 5 },
  { label: "six", value: 6 },
];

function App() {
  const [value1, setValue1] = useState([options[0]]);
  const [value2, setValue2] = useState(options[0]);
  
  const defaultSelected = [
    { label: "Second", value: 2 },
    { label: "Third", value: 3 },
  ];
  const [selectedOptions, setSelectedOptions] = useState(defaultSelected)

  const handleMultiSelectChange = (options) => {
    setSelectedOptions(options);
  };

  // console.log(selectedOptions);

  return (
    <div className="w-[100vw] h-[100vh] flex items-center justify-center">
      {/* <Select options={options} value={value2} onChange={o => setValue2(o)} /> */}
      <MultiSelect
        options={options}
        placeholder="search for options"
        // alwaysShowPlaceholder={true}
        // searchable={false}
        // defaultOpt={defaultSelected}
        // defaultMenuIsOpen={true}
        // defaultInputValue="t"
        // style
        // onChange={handleMultiSelectChange}
      />
    </div>
  );
}

export default App;
